module.exports = __webpack_public_path__ + "img/credit-card-group.065d376.png";